import { getServerProps } from "../utils/server";
let pathPrefix = getServerProps().pathPrefix;
export { pathPrefix };
